module.exports = __webpack_public_path__ + "static/media/certificate-2.f765227f.svg";